<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>商品管理>产品套餐</BreadcrumbItem>
      </Breadcrumb>
      <Card>
        <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
          <span class="search_span_width">
              <span class="search_span_width_part1">商品ID:</span>
            <Input v-model="search.id" placeholder="请输入内容" clearable :style="{'width':'150px'}"></Input>
          </span>
          <span class="search_span_width">
                <span class="search_span_width_part1">产品名称:</span>
              <Input v-model="search.name" placeholder="请输入内容" clearable :style="{'width':'150px'}"></Input>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">上架渠道：</span>
            <Select v-model="search.channel" clearable style="width:200px">
              <Option v-for="item in channel_list" :value="item.id" :key="item.index">{{ item.name }}</Option>
            </Select>
          </span>
          <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="listingProduct(1)">搜索</Button>
        </Card>
        <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
          <span :style="{'text-align':'center','float':'left'}">
            <Button type='primary'  @click="$router.push('/goods/goodsGroupInfo')">添加产品套餐</Button>
          </span>
        </p>
       <Card>
          <Table :columns="producetListingColumns" :data="producet_list"></Table>
          <Page :total="recordListingTotal" :current="listingPage" :page-size="15" :show-elevator="true" @on-change="listingProduct"/>
        </Card>

      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      split: 0.5,
      search : {
        channel:'',
        name:'',
        product_type:3,
        is_channel:2,
      },
      productChannelInfo:{
        id:0,
        product_id:0,
        product_name:"",
		product_cate:0,
        agent_config:[],
        channel:'',
        ori_total_fee:0,
        total_fee:0,
        details:'',
        is_listing:1,
        grade_0:0,
        grade_name_0:"渠道管理员",
        agent_zero_price:0,
        grade_1:1,
        grade_name_1:"钻石服务商",
        agent_one_price:0,
        grade_2:2,
        grade_name_2:"运营服务商",
        agent_two_price:0,
        agent_channel_config:[],
        remark:''
      },
    recordTotal:0,
    page:1,
    listingPage:1,
    recordListingTotal:0,
		channel_list:[],
    producet_list:[],
    producetListingColumns:[
      { title: '商品ID', key: 'id', align: 'center' },
      { title: '产品名称', key: 'product_name', align: 'center' },
	  { title: '描述', key: 'remark', align: 'center' },
      { title: '商品类型', key: 'product_type', align: 'center', render:(h,params) =>{
          let product_type = '单品';
          if (params.row.product_type == '1') {
            product_type = '单品';
          }else if (params.row.product_type == '2') {
            product_type = '服务';
          }else if (params.row.product_type == '3') {
            product_type = '产品套餐';
          }
          return h('span',{},product_type);
        }},
      { title: '产品套餐原价', key: 'ori_total_fee', align: 'center', render:(h,params) =>{
          let ori_total_fee = "0";
          let unit_name = params.row.unit_name;
          if (params.row.ori_total_fee >0) {
            ori_total_fee = '￥' + params.row.ori_total_fee + '/' + unit_name;
          }else {
            ori_total_fee = params.row.ori_total_fee + '/' + unit_name;
          }
          return h('span',{},ori_total_fee);
        }},
      { title: '产品套餐零售价', key: 'total_fee', align: 'center', render:(h,params) =>{
          let total_fee = "0";
          let unit_name = params.row.unit_name;
          if (params.row.total_fee >0) {
            total_fee = '￥' + params.row.total_fee + '/' + unit_name;
          }else {
            total_fee = params.row.total_fee + '/' + unit_name;
          }
          return h('span',{},total_fee);
        }},
      { title: '操作', key: 'action', align: 'center',
        render: (h, params) => {
          let btns=[]
          btns.push(
              h('Button', {
                props: { type: 'warning', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.$router.push('/goods/goodsGroupInfo?id='+params.row.id)
                  }
                }
              }, '编辑'),
          );
          return h("div",btns);
        },
      }
    ],
	}
  },
  mounted:function(){
    this.listingProduct();
    this.getChannel();
  },
  computed:{
    getUploadUrl(){
      return process.env.VUE_APP_APIHOST+'/admin/channel/upload';
    },
  },
  methods:{
  getChannel() {
    this.http.get('/admin/common/getChannelList',{params:{'key':'app_channel'}}).then(response=>{
      let data=response.data;
      console.log(data);
      if(data.code!==0){
        alert(data.message);
      } else{
        this.channel_list = data.data;
      }
    }).catch(()=>{
      this.$Message.error('网络错误');
    });
  },
  listingProduct(page=this.listingPage){
    this.page = page;
    let p = {'page' : page}
    let params = Object.assign(this.search, p);
    this.http1.get('/produce/producetList',{params:params}).then(response=>{
      let data=response.data;
      if(data.code!==0) {
        this.$Message.error(data.message);
        return false;
      } else{
        this.producet_list = data.data.list;
        this.recordListingTotal = data.data.total;
      }
    });
  },
    closesavemodal(){
		this.showsavemodal=false;
    }
  }

}
</script>


<style lang='postcss'>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.box > div {
  height: 100%;
  flex: 1;
}
</style>